import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component({
	components: {},
})
export default class Anchor extends Vue {
	@Prop() link
}
